import { Box, TextField, Typography } from '@mui/material';
import { JSXInternal } from 'preact/src/jsx';
import { Component, createRef } from 'react';
import AppManager from '../../commun/AppManager';
import { Spinner } from '../../commun/component/Spinner';
import { Color } from '../../commun/Constant';
import { post } from '../../commun/HTTP';
import Result from '../../commun/Result';
import Toast from '../../commun/toast/Toast';
import { Paper } from '../../object/Paper';
import Category from '../../object/tag/Category';
import { getErrorMessage } from '../../utils/Error';
import MpModal, { IBaseModalProps } from '../extends/MpModal';
import { SelectColor } from '../SelectColor';

export interface IChoosePaperModalProps extends IBaseModalProps {
    paper: Paper;
}

export interface IChoosePaperModalState {
    loading: boolean;
    error: string;
}

export default class ChoosePaperModal extends Component<IChoosePaperModalProps, IChoosePaperModalState> {
    constructor(props: IChoosePaperModalProps) {
        super(props);

        this.state = this.initState();
    }

    initState() {
        const p: IChoosePaperModalState = {
            loading: false,
            error: '',
        };
        return p;
    }

    componentDidUpdate(
        prevProps: Readonly<IChoosePaperModalProps>,
        prevState: Readonly<IChoosePaperModalState>,
        snapshot?: any,
    ): void {
        if (prevProps.open !== this.props.open) {
            this.setState(this.initState());
        }
    }

    addVendor() {
        this.setState({
            loading: true,
            error: '',
        });
        post('/paper/choose', {
            id: this.props.paper.getAjoIdentifier(),
            id_devis: this.props.paper.getDevis()!.getAjoIdentifier(),
        }).then((res: any) => {
            this.setState({
                loading: false,
            });
            if (Result.isSuccess(res)) {
                Result.applyResult(res, AppManager.updater(), true);

                AppManager.addToast(new Toast('La feuille a été choisie avec succès.', 'success'));
                this.props.onClose();
            } else {
                this.setState({
                    error: getErrorMessage(Result.getErrorStr(res)),
                });
            }
        });
    }

    render(): JSXInternal.Element {
        const { open, onClose } = this.props;
        const { loading, error } = this.state;
        return (
            <MpModal
                open={open}
                onClose={onClose}
                onSubmit={() => {
                    this.addVendor();
                }}
                title={'Choisir une feuille'}
                done={'Choisir'}
            >
                {loading ? (
                    <Box className="flex items-center justify-center py-12">
                        <Spinner color="blue" className="" />
                    </Box>
                ) : (
                    <Box className="flex flex-col !text-gray-700 gap-3">
                        <Typography className="!font-medium">
                            Voulez-vous vraiment Choisir cette feuille ?<br />
                            La feuille choisie sera la feuille utilisée pour le budget du prix de vente.
                        </Typography>

                        {error !== '' && (
                            <Typography
                                component={'p'}
                                className="!text-sm text-red-600 !mt-1 !mb-1 !font-medium text-center"
                            >
                                {error}
                            </Typography>
                        )}
                    </Box>
                )}
            </MpModal>
        );
    }
}
